import type { IAsset } from '@frontend/components/interfaces/asset';
import type { ICustomControlRequestReadProps } from '@frontend/components/pages/customControls/interfaces/customControlRequestReadProps';
import { UserTextParagraph } from '@frontend/components/elements/common';
import { FormLabel } from '@frontend/components/elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '@frontend/components/elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '@frontend/components/elements/forms/InputContainer';
import { AssetThumbnailsWithHeader } from '@frontend/components/pages/episodes/common';
import type { IDermaSnelCscV1RequestAddEditCustomControlData } from './DermaSnelCscV1RequestAddEdit';

interface IDermaSnelCscV1RequestSummaryProps extends ICustomControlRequestReadProps {
    orderedAssets: IAsset[];
}

export function DermaSnelCscV1RequestSummary(props: IDermaSnelCscV1RequestSummaryProps) {
    const customControlData: IDermaSnelCscV1RequestAddEditCustomControlData = props.request.customControlData;

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>Vraag</FormLabel>
                <InputContainer>
                    {customControlData.vraag.verdacht_van_kwaadaardigheid && (
                        <UserTextParagraph>Verdacht van kwaadaardigheid?</UserTextParagraph>
                    )}
                    {customControlData.vraag.expectatief_beleid && (
                        <UserTextParagraph>Expectatief beleid?</UserTextParagraph>
                    )}
                    {customControlData.vraag.diagnostiek_en_behandeling && (
                        <UserTextParagraph>Insturen voor diagnostiek en behandeling?</UserTextParagraph>
                    )}
                    {customControlData.vraag.anders !== null && (
                        <UserTextParagraph>{customControlData.vraag.anders}</UserTextParagraph>
                    )}
                </InputContainer>
            </HorizontalFormGroupRead>

            <AssetThumbnailsWithHeader
                assets={props.orderedAssets}
                id={props.request.id}
            />
        </>
    );
}
